import { z } from 'zod'
import { creatorListQueryShape } from '../list-query/contract.ts'

export const SUPER_ADMIN_ROLE_CODE = 'super_admin'

export type PermissionDefinition = {
  code: string
  name: string
  module: string
  kind: 'route' | 'operation'
  effect?: 'read' | 'write'
  requires: readonly string[]
  superAdminOnly: boolean
  order: number
}

// 目录由代码维护。角色仅保存明确编码，目录新增项不会自动扩展普通角色。
export const permissionDefinitions = [
  {
    code: 'bot.read',
    name: '查看机器人',
    module: '机器人',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 2000
  },
  {
    code: 'bot.create',
    name: '新增机器人',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: false,
    order: 2001
  },
  {
    code: 'bot.update',
    name: '修改机器人',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: false,
    order: 2002
  },
  {
    code: 'bot.delete',
    name: '删除机器人',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: false,
    order: 2009
  },
  {
    code: 'bot.status.update',
    name: '启停机器人',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: false,
    order: 2003
  },
  {
    code: 'bot.permission.update',
    name: '分配机器人权限',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: true,
    order: 2004
  },
  {
    code: 'bot.credential.update',
    name: '管理机器人凭据',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: true,
    order: 2005
  },
  {
    code: 'bot.training.update',
    name: '管理机器人调教',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: true,
    order: 2006
  },
  {
    code: 'bot.push.test',
    name: '测试企微主动推送',
    module: '机器人',
    kind: 'operation',
    effect: 'write',
    requires: ['bot.read'],
    superAdminOnly: true,
    order: 2010
  },
  {
    code: 'bill.group.send',
    name: '发送收款单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 2007
  },
  {
    code: 'route.bots',
    name: '机器人管理',
    module: '机器人',
    kind: 'route',
    effect: 'read',
    requires: ['bot.read'],
    superAdminOnly: false,
    order: 2008
  },
  {
    code: 'account.read',
    name: '查看账号',
    module: '账号',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 0
  },
  {
    code: 'account.status.update',
    name: '启停账号',
    module: '账号',
    kind: 'operation',
    effect: 'write',
    requires: ['account.read'],
    superAdminOnly: false,
    order: 1
  },
  {
    code: 'account.roles.assign',
    name: '分配账号角色',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['account.read'],
    superAdminOnly: true,
    order: 2
  },
  {
    code: 'account.application.read',
    name: '查看账号申请',
    module: '系统授权',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: true,
    order: 3
  },
  {
    code: 'account.application.approve',
    name: '通过账号申请',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['account.application.read'],
    superAdminOnly: true,
    order: 4
  },
  {
    code: 'account.application.reject',
    name: '驳回账号申请',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['account.application.read'],
    superAdminOnly: true,
    order: 5
  },
  {
    code: 'role.read',
    name: '查看角色',
    module: '系统授权',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: true,
    order: 6
  },
  {
    code: 'role.create',
    name: '新增角色',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['role.read'],
    superAdminOnly: true,
    order: 7
  },
  {
    code: 'role.update',
    name: '修改角色',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['role.read'],
    superAdminOnly: true,
    order: 8
  },
  {
    code: 'role.status.update',
    name: '启停角色',
    module: '系统授权',
    kind: 'operation',
    effect: 'write',
    requires: ['role.read'],
    superAdminOnly: true,
    order: 9
  },

  {
    code: 'member.read',
    name: '查看成员',
    module: '成员',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 11
  },
  {
    code: 'member.employee.create',
    name: '新增员工',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 12
  },
  {
    code: 'member.employee.update',
    name: '修改员工',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 13
  },
  {
    code: 'member.employee.status.update',
    name: '启停员工',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 14
  },
  {
    code: 'member.agent.create',
    name: '新增代理商',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 15
  },
  {
    code: 'member.agent.update',
    name: '修改代理商',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 16
  },
  {
    code: 'member.agent.status.update',
    name: '启停代理商',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 17
  },
  {
    code: 'member.delete',
    name: '删除成员',
    module: '成员',
    kind: 'operation',
    effect: 'write',
    requires: ['member.read'],
    superAdminOnly: true,
    order: 18
  },
  {
    code: 'customer.read',
    name: '查看客户档案',
    module: '客户',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 19
  },
  {
    code: 'customer.create',
    name: '新增客户档案',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 20
  },
  {
    code: 'customer.update',
    name: '修改客户档案',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 21
  },
  {
    code: 'customer.delete',
    name: '删除客户档案',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 22
  },
  {
    code: 'customer.status.update',
    name: '启停客户档案',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 23
  },
  {
    code: 'customer.billing.update',
    name: '修改客户月结配置',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 24
  },
  {
    code: 'customer.chatBinding.update',
    name: '管理客户群绑定',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 26
  },
  {
    code: 'customer.tag.read',
    name: '查看客户标签',
    module: '客户',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 25
  },
  {
    code: 'customer.tag.create',
    name: '新增客户标签',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.tag.read'],
    superAdminOnly: false,
    order: 26
  },
  {
    code: 'customer.tag.update',
    name: '修改客户标签',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.tag.read'],
    superAdminOnly: false,
    order: 27
  },
  {
    code: 'customer.tag.delete',
    name: '删除客户标签',
    module: '客户',
    kind: 'operation',
    effect: 'write',
    requires: ['customer.tag.read'],
    superAdminOnly: false,
    order: 28
  },
  {
    code: 'subject.read',
    name: '查看服务对象',
    module: '服务对象',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 29
  },
  {
    code: 'subject.create',
    name: '新增服务对象',
    module: '服务对象',
    kind: 'operation',
    effect: 'write',
    requires: ['subject.read'],
    superAdminOnly: false,
    order: 30
  },
  {
    code: 'subject.update',
    name: '修改服务对象',
    module: '服务对象',
    kind: 'operation',
    effect: 'write',
    requires: ['subject.read'],
    superAdminOnly: false,
    order: 31
  },
  {
    code: 'subject.material.update',
    name: '补充材料：服务对象',
    module: '服务对象',
    kind: 'operation',
    effect: 'write',
    requires: ['subject.read'],
    superAdminOnly: false,
    order: 32
  },
  {
    code: 'subject.archive',
    name: '归档服务对象',
    module: '服务对象',
    kind: 'operation',
    effect: 'write',
    requires: ['subject.read'],
    superAdminOnly: false,
    order: 33
  },
  {
    code: 'order.group.read',
    name: '查看订单组',
    module: '订单',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 34
  },
  {
    code: 'order.group.create',
    name: '新增订单组',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.group.read'],
    superAdminOnly: false,
    order: 35
  },
  {
    code: 'order.group.update',
    name: '修改订单组',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.group.read'],
    superAdminOnly: false,
    order: 36
  },
  {
    code: 'order.group.delete',
    name: '删除订单组',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.group.read'],
    superAdminOnly: false,
    order: 37
  },
  {
    code: 'order.rental.read',
    name: '查看租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 38
  },
  {
    code: 'order.rental.create',
    name: '新增租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 39
  },
  {
    code: 'order.rental.update',
    name: '修改租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 40
  },
  {
    code: 'order.rental.delete',
    name: '删除租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 41
  },
  {
    code: 'order.rental.activate',
    name: '生效租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 42
  },
  {
    code: 'order.rental.cancel',
    name: '取消租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 43
  },
  {
    code: 'order.rental.archive',
    name: '归档租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 44
  },
  {
    code: 'order.rental.end',
    name: '结束租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 45
  },
  {
    code: 'order.rental.renew',
    name: '续约租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read', 'order.rental.create'],
    superAdminOnly: false,
    order: 46
  },
  {
    code: 'order.rental.material.update',
    name: '补充材料：租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 47
  },
  {
    code: 'order.rental.forceDelete',
    name: '强制删除租赁订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.rental.read'],
    superAdminOnly: true,
    order: 48
  },
  {
    code: 'order.service.read',
    name: '查看服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 49
  },
  {
    code: 'order.service.create',
    name: '新增服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 50
  },
  {
    code: 'order.service.update',
    name: '修改服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 51
  },
  {
    code: 'order.service.delete',
    name: '删除服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 52
  },
  {
    code: 'order.service.activate',
    name: '生效服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 53
  },
  {
    code: 'order.service.cancel',
    name: '取消服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 54
  },
  {
    code: 'order.service.archive',
    name: '归档服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 55
  },
  {
    code: 'order.service.complete',
    name: '完成服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 56
  },
  {
    code: 'order.service.terminate',
    name: '终止服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 57
  },
  {
    code: 'order.service.reprice',
    name: '调价服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 58
  },
  {
    code: 'order.service.renew',
    name: '续约服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read', 'order.service.create'],
    superAdminOnly: false,
    order: 59
  },
  {
    code: 'order.service.forceDelete',
    name: '强制删除服务订单',
    module: '订单',
    kind: 'operation',
    effect: 'write',
    requires: ['order.service.read'],
    superAdminOnly: true,
    order: 60
  },
  {
    code: 'bill.read',
    name: '查看账单',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 61
  },
  {
    code: 'bill.create',
    name: '新增账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 62
  },
  {
    code: 'bill.update',
    name: '修改账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 63
  },
  {
    code: 'bill.delete',
    name: '删除账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 64
  },
  {
    code: 'bill.generate',
    name: '生成账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 65
  },
  {
    code: 'bill.issue',
    name: '签发账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 66
  },
  {
    code: 'bill.adjust',
    name: '调整账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 67
  },
  {
    code: 'bill.void',
    name: '作废账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 68
  },
  {
    code: 'bill.archive',
    name: '归档账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 69
  },
  {
    code: 'bill.rule.update',
    name: '修改收费规则：账单',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 70
  },
  {
    code: 'bill.group.read',
    name: '查看收款账单组',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 71
  },
  {
    code: 'bill.group.create',
    name: '新增收款账单组',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 72
  },
  {
    code: 'bill.group.update',
    name: '修改收款账单组',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 73
  },
  {
    code: 'bill.group.issue',
    name: '签发收款账单组',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 74
  },
  {
    code: 'bill.group.void',
    name: '作废收款账单组',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 75
  },
  {
    code: 'bill.automation.read',
    name: '查看自动化执行记录',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 76
  },
  {
    code: 'bill.automation.retry',
    name: '重试自动化任务',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['bill.automation.read'],
    superAdminOnly: false,
    order: 77
  },
  {
    code: 'money.read',
    name: '查看资金流水',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 78
  },
  {
    code: 'bill.receipt.record',
    name: '记录收款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 79
  },
  {
    code: 'bill.receipt.confirm',
    name: '确认收款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 80
  },
  {
    code: 'bill.receipt.void',
    name: '作废收款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 81
  },
  {
    code: 'bill.payment.record',
    name: '记录付款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 82
  },
  {
    code: 'bill.payment.confirm',
    name: '确认付款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 83
  },
  {
    code: 'bill.payment.void',
    name: '作废付款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 84
  },
  {
    code: 'bill.refund.record',
    name: '记录退款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 85
  },
  {
    code: 'bill.refund.confirm',
    name: '确认退款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 86
  },
  {
    code: 'bill.refund.void',
    name: '作废退款',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 87
  },
  {
    code: 'expense.read',
    name: '查看支出登记',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 88
  },
  {
    code: 'expense.create',
    name: '新增支出登记',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['expense.read'],
    superAdminOnly: false,
    order: 89
  },
  {
    code: 'expense.update',
    name: '修改支出登记',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['expense.read'],
    superAdminOnly: false,
    order: 90
  },
  {
    code: 'expense.delete',
    name: '删除支出登记',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['expense.read'],
    superAdminOnly: false,
    order: 91
  },
  {
    code: 'expense.import',
    name: '导入支出登记',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['expense.read'],
    superAdminOnly: false,
    order: 92
  },
  {
    code: 'payee.read',
    name: '查看付款对象',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 93
  },
  {
    code: 'payee.create',
    name: '新增付款对象',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['payee.read'],
    superAdminOnly: false,
    order: 94
  },
  {
    code: 'payee.update',
    name: '修改付款对象',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['payee.read'],
    superAdminOnly: false,
    order: 95
  },
  {
    code: 'payee.status.update',
    name: '启停付款对象',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['payee.read'],
    superAdminOnly: false,
    order: 96
  },
  {
    code: 'organization.account.read',
    name: '查看收付账户',
    module: '财务',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 97
  },
  {
    code: 'organization.account.create',
    name: '新增收付账户',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.account.read'],
    superAdminOnly: false,
    order: 98
  },
  {
    code: 'organization.account.update',
    name: '修改收付账户',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.account.read'],
    superAdminOnly: false,
    order: 99
  },
  {
    code: 'organization.account.status.update',
    name: '启停收付账户',
    module: '财务',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.account.read'],
    superAdminOnly: false,
    order: 100
  },
  {
    code: 'report.read',
    name: '查看经营报表',
    module: '报表',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 101
  },
  {
    code: 'site.read',
    name: '查看场地',
    module: '基础资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 102
  },
  {
    code: 'site.create',
    name: '新增场地',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['site.read'],
    superAdminOnly: false,
    order: 103
  },
  {
    code: 'site.update',
    name: '修改场地',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['site.read'],
    superAdminOnly: false,
    order: 104
  },
  {
    code: 'site.delete',
    name: '删除场地',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['site.read'],
    superAdminOnly: false,
    order: 105
  },
  {
    code: 'site.status.update',
    name: '启停场地',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['site.read'],
    superAdminOnly: false,
    order: 106
  },
  {
    code: 'room.read',
    name: '查看房源',
    module: '基础资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 107
  },
  {
    code: 'room.create',
    name: '新增房源',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['room.read'],
    superAdminOnly: false,
    order: 108
  },
  {
    code: 'room.update',
    name: '修改房源',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['room.read'],
    superAdminOnly: false,
    order: 109
  },
  {
    code: 'room.delete',
    name: '删除房源',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['room.read'],
    superAdminOnly: false,
    order: 110
  },
  {
    code: 'room.status.update',
    name: '启停房源',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['room.read'],
    superAdminOnly: false,
    order: 111
  },
  {
    code: 'business.read',
    name: '查看业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 112
  },
  {
    code: 'business.create',
    name: '新增业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['business.read'],
    superAdminOnly: false,
    order: 113
  },
  {
    code: 'business.update',
    name: '修改业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['business.read'],
    superAdminOnly: false,
    order: 114
  },
  {
    code: 'business.delete',
    name: '删除业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['business.read'],
    superAdminOnly: false,
    order: 115
  },
  {
    code: 'business.status.update',
    name: '启停业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['business.read'],
    superAdminOnly: false,
    order: 116
  },
  {
    code: 'expenseBusiness.read',
    name: '查看支出业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 117
  },
  {
    code: 'expenseBusiness.create',
    name: '新增支出业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['expenseBusiness.read'],
    superAdminOnly: false,
    order: 118
  },
  {
    code: 'expenseBusiness.update',
    name: '修改支出业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['expenseBusiness.read'],
    superAdminOnly: false,
    order: 119
  },
  {
    code: 'expenseBusiness.delete',
    name: '删除支出业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['expenseBusiness.read'],
    superAdminOnly: false,
    order: 120
  },
  {
    code: 'expenseBusiness.status.update',
    name: '启停支出业务',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['expenseBusiness.read'],
    superAdminOnly: false,
    order: 121
  },
  {
    code: 'organization.read',
    name: '查看经营主体',
    module: '基础资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 122
  },
  {
    code: 'organization.create',
    name: '新增经营主体',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.read'],
    superAdminOnly: false,
    order: 123
  },
  {
    code: 'organization.update',
    name: '修改经营主体',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.read'],
    superAdminOnly: false,
    order: 124
  },
  {
    code: 'organization.delete',
    name: '删除经营主体',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.read'],
    superAdminOnly: false,
    order: 125
  },
  {
    code: 'organization.status.update',
    name: '启停经营主体',
    module: '基础资料',
    kind: 'operation',
    effect: 'write',
    requires: ['organization.read'],
    superAdminOnly: false,
    order: 126
  },
  {
    code: 'company.read',
    name: '查看企业资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 130
  },
  {
    code: 'company.create',
    name: '新增企业资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['company.read'],
    superAdminOnly: false,
    order: 131
  },
  {
    code: 'company.update',
    name: '修改企业资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['company.read'],
    superAdminOnly: false,
    order: 132
  },
  {
    code: 'company.lookup',
    name: '外部查询：企业资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['company.read'],
    superAdminOnly: false,
    order: 133
  },
  {
    code: 'identity.read',
    name: '查看法人资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 134
  },
  {
    code: 'identity.create',
    name: '新增法人资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['identity.read'],
    superAdminOnly: false,
    order: 135
  },
  {
    code: 'identity.update',
    name: '修改法人资料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['identity.read'],
    superAdminOnly: false,
    order: 136
  },
  {
    code: 'ocr.businessLicense',
    name: '识别营业执照',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: [],
    superAdminOnly: false,
    order: 137
  },
  {
    code: 'ocr.idCard',
    name: '识别身份证',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: [],
    superAdminOnly: false,
    order: 138
  },
  {
    code: 'license.recognize',
    name: '识别执照与法人材料',
    module: '证件资料',
    kind: 'operation',
    effect: 'write',
    requires: ['ocr.businessLicense', 'ocr.idCard'],
    superAdminOnly: false,
    order: 139
  },
  {
    code: 'contract.template.read',
    name: '查看合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 140
  },
  {
    code: 'contract.template.create',
    name: '新增合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 141
  },
  {
    code: 'contract.template.update',
    name: '修改合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 142
  },
  {
    code: 'contract.template.delete',
    name: '删除合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 143
  },
  {
    code: 'contract.template.status.update',
    name: '启停合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 144
  },
  {
    code: 'contract.template.publish',
    name: '发布合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 145
  },
  {
    code: 'contract.template.restore',
    name: '恢复版本：合同模板',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 146
  },
  {
    code: 'contract.document.read',
    name: '查看合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'read',
    requires: [],
    superAdminOnly: false,
    order: 152
  },
  {
    code: 'contract.document.create',
    name: '新增合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 153
  },
  {
    code: 'contract.document.update',
    name: '修改合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 154
  },
  {
    code: 'contract.document.activate',
    name: '生效合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 155
  },
  {
    code: 'contract.document.void',
    name: '作废合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 156
  },
  {
    code: 'contract.document.confirm',
    name: '确认合同文件',
    module: '合同',
    kind: 'operation',
    effect: 'write',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 157
  },
  {
    code: 'route.customers',
    name: '访问客户档案页面',
    module: '客户',
    kind: 'route',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 158
  },
  {
    code: 'route.customerCalendar',
    name: '访问客户台历页面',
    module: '客户',
    kind: 'route',
    requires: ['customer.read'],
    superAdminOnly: false,
    order: 159
  },
  {
    code: 'route.customerTags',
    name: '访问客户标签页面',
    module: '客户',
    kind: 'route',
    requires: ['customer.tag.read'],
    superAdminOnly: false,
    order: 159
  },
  {
    code: 'route.subjects',
    name: '访问服务对象页面',
    module: '服务对象',
    kind: 'route',
    requires: ['subject.read'],
    superAdminOnly: false,
    order: 160
  },
  {
    code: 'route.orders.rentals',
    name: '访问租赁订单页面',
    module: '订单',
    kind: 'route',
    requires: ['order.rental.read'],
    superAdminOnly: false,
    order: 161
  },
  {
    code: 'route.orders.service',
    name: '访问服务订单页面',
    module: '订单',
    kind: 'route',
    requires: ['order.service.read'],
    superAdminOnly: false,
    order: 162
  },
  {
    code: 'route.orders.groups',
    name: '访问订单组页面',
    module: '订单',
    kind: 'route',
    requires: ['order.group.read'],
    superAdminOnly: false,
    order: 163
  },
  {
    code: 'route.finance.bills',
    name: '访问收款账单页面',
    module: '财务',
    kind: 'route',
    requires: ['bill.read'],
    superAdminOnly: false,
    order: 164
  },
  {
    code: 'route.finance.groups',
    name: '访问收款账单组页面',
    module: '财务',
    kind: 'route',
    requires: ['bill.group.read'],
    superAdminOnly: false,
    order: 165
  },
  {
    code: 'route.finance.expenses',
    name: '访问支出账单页面',
    module: '财务',
    kind: 'route',
    requires: ['expense.read'],
    superAdminOnly: false,
    order: 166
  },
  {
    code: 'route.finance.money',
    name: '访问资金流水页面',
    module: '财务',
    kind: 'route',
    requires: ['money.read'],
    superAdminOnly: false,
    order: 167
  },
  {
    code: 'route.contracts.templates',
    name: '访问合同模板页面',
    module: '合同',
    kind: 'route',
    requires: ['contract.template.read'],
    superAdminOnly: false,
    order: 168
  },
  {
    code: 'route.contracts.documents',
    name: '访问合同文件页面',
    module: '合同',
    kind: 'route',
    requires: ['contract.document.read'],
    superAdminOnly: false,
    order: 170
  },
  {
    code: 'route.contracts.variables',
    name: '访问动态字段页面',
    module: '合同',
    kind: 'route',
    requires: [],
    superAdminOnly: false,
    order: 171
  },
  {
    code: 'route.address.sites',
    name: '访问场地页面',
    module: '基础资料',
    kind: 'route',
    requires: ['site.read'],
    superAdminOnly: false,
    order: 172
  },
  {
    code: 'route.address.rooms',
    name: '访问房源页面',
    module: '基础资料',
    kind: 'route',
    requires: ['room.read'],
    superAdminOnly: false,
    order: 173
  },
  {
    code: 'route.licenses',
    name: '访问执照页面',
    module: '证件资料',
    kind: 'route',
    requires: ['company.read', 'identity.read'],
    superAdminOnly: false,
    order: 174
  },
  {
    code: 'route.masterData.businesses',
    name: '访问业务页面',
    module: '基础资料',
    kind: 'route',
    requires: ['business.read'],
    superAdminOnly: false,
    order: 175
  },
  {
    code: 'route.masterData.expenseBusinesses',
    name: '访问支出业务页面',
    module: '基础资料',
    kind: 'route',
    requires: ['expenseBusiness.read'],
    superAdminOnly: false,
    order: 176
  },
  {
    code: 'route.masterData.organizations',
    name: '访问经营主体页面',
    module: '基础资料',
    kind: 'route',
    requires: ['organization.read'],
    superAdminOnly: false,
    order: 177
  },
  {
    code: 'route.access.members',
    name: '访问成员页面',
    module: '成员',
    kind: 'route',
    requires: ['member.read'],
    superAdminOnly: false,
    order: 178
  },
  {
    code: 'route.access.accounts',
    name: '访问账号页面',
    module: '账号',
    kind: 'route',
    requires: ['account.read'],
    superAdminOnly: false,
    order: 179
  },
  {
    code: 'route.system.roles',
    name: '访问角色权限页面',
    module: '系统授权',
    kind: 'route',
    requires: ['role.read'],
    superAdminOnly: true,
    order: 180
  },

  {
    code: 'route.reports.overview',
    name: '访问经营总览页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 182
  },
  {
    code: 'route.reports.organizations',
    name: '访问主体分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 183
  },
  {
    code: 'route.reports.customers',
    name: '访问客户分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 184
  },
  {
    code: 'route.reports.salespeople',
    name: '访问业务员分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 185
  },
  {
    code: 'route.reports.sites',
    name: '访问地址分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 186
  },
  {
    code: 'route.reports.businesses',
    name: '访问业务分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 187
  },
  {
    code: 'route.reports.subjects',
    name: '访问服务对象分析页面',
    module: '报表',
    kind: 'route',
    requires: ['report.read'],
    superAdminOnly: false,
    order: 188
  }
] as const satisfies readonly PermissionDefinition[]

export const permissionCodes = permissionDefinitions.map((item) => item.code) as [
  (typeof permissionDefinitions)[number]['code'],
  ...(typeof permissionDefinitions)[number]['code'][]
]
export const permissionCodeSchema = z.enum(permissionCodes)
export type PermissionCode = z.infer<typeof permissionCodeSchema>
export const permissionByCode = new Map<string, PermissionDefinition>(
  permissionDefinitions.map((item) => [item.code, item])
)

export type PermissionSession = { isSuperAdmin: boolean; permissions: readonly PermissionCode[] }
export function hasPermission(session: PermissionSession, code: PermissionCode): boolean {
  const definition = permissionByCode.get(code)
  if (!definition) return false
  if (session.isSuperAdmin) return true
  if (definition.superAdminOnly || !session.permissions.includes(code)) return false
  return definition.requires.every((required) => hasPermission(session, required as PermissionCode))
}
export function hasAllPermissions(session: PermissionSession, codes: readonly PermissionCode[]) {
  return codes.every((code) => hasPermission(session, code))
}
export function hasAnyPermission(session: PermissionSession, codes: readonly PermissionCode[]) {
  return codes.some((code) => hasPermission(session, code))
}

export function permissionClosure(codes: readonly PermissionCode[]): PermissionCode[] {
  const selected = new Set<PermissionCode>()
  function visit(code: PermissionCode) {
    if (selected.has(code)) return
    selected.add(code)
    for (const required of permissionByCode.get(code)?.requires ?? []) visit(permissionCodeSchema.parse(required))
  }
  for (const code of codes) visit(code)
  return [...selected]
}

export function removePermissionDependents(codes: readonly PermissionCode[], removed: readonly PermissionCode[]) {
  const selected = new Set(codes)
  for (const code of removed) selected.delete(code)
  let changed = true
  while (changed) {
    changed = false
    for (const code of selected) {
      if (permissionByCode.get(code)?.requires.some((required) => !selected.has(required as PermissionCode))) {
        selected.delete(code)
        changed = true
      }
    }
  }
  return [...selected]
}

export const roleListSchema = z.object({
  current: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(20),
  id: z.uuid().optional(),
  keyword: z.string().trim().max(100).optional(),
  isEnabled: z.boolean().optional(),
  ...creatorListQueryShape,
  sortField: z.enum(['createdAt', 'name']).default('createdAt'),
  sortOrder: z.enum(['asc', 'desc']).default('desc')
})
const roleFields = {
  name: z.string().trim().min(2, '角色名称至少 2 个字').max(80, '角色名称最多 80 个字'),
  description: z.string().trim().max(500).nullable().optional(),
  isEnabled: z.boolean().default(true),
  permissionCodes: z.array(permissionCodeSchema),
  catalogVersion: z.string().min(1).max(100)
}
export const createRoleSchema = z.strictObject({
  code: z
    .string()
    .trim()
    .min(2)
    .max(50)
    .regex(/^[a-z][a-z0-9_]*$/, '使用小写字母、数字和下划线'),
  ...roleFields
})
export const updateRoleSchema = z.strictObject({
  roleId: z.uuid(),
  expectedVersion: z.number().int().min(1),
  ...roleFields
})
export const roleIdSchema = z.object({ roleId: z.uuid() })
export const roleBatchEnabledSchema = z.strictObject({
  roles: z
    .array(z.object({ roleId: z.uuid(), expectedVersion: z.number().int().min(1) }))
    .min(1)
    .max(100),
  isEnabled: z.boolean()
})
export const roleAccountListSchema = roleListSchema.pick({ current: true, pageSize: true, keyword: true }).extend({
  roleId: z.uuid(),
  id: z.number().int().positive().optional(),
  status: z.enum(['pendingApproval', 'active', 'rejected', 'suspended']).optional()
})
export const roleOptionsSchema = z.object({
  current: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(20),
  keyword: z.string().trim().max(100).optional(),
  selectedIds: z.array(z.uuid()).max(100).default([])
})
export type RoleListInput = z.infer<typeof roleListSchema>
export type CreateRoleInput = z.infer<typeof createRoleSchema>
export type UpdateRoleInput = z.infer<typeof updateRoleSchema>
export type RoleBatchEnabledInput = z.infer<typeof roleBatchEnabledSchema>
export type RoleAccountListInput = z.infer<typeof roleAccountListSchema>
export type RoleOptionsInput = z.infer<typeof roleOptionsSchema>
